import React from 'react';
import { useMsal } from '@azure/msal-react';
import { useUserInfo } from '../hooks/useUserInfo';
import userLogo from '../assets/logo.png';
import logoMobile from '../assets/logoMobile.png';
import logoWim from '../assets/LogoWim.png';

import './Header.css';

export const Header: React.FC = () => {
  const { instance } = useMsal();
  const userInfo = useUserInfo();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <img src={logoWim} alt="WIJeindhoven" className="header-logo header-logo-desktop" />
          <img src={logoWim} alt="WIJ" className="header-logo header-logo-mobile" />
          <div className="header-title">
            <h1>WIM</h1>
            <span className="header-subtitle">WIJeindhoven Intelligentie Maatje</span>
          </div>
        </div>

        {userInfo && (
          <div className="header-user">
            <img src={userLogo} alt="WIJeindhoven" className="header-user-logo header-user-logo-desktop" />
            <div className="header-user-content">
              <div className="user-info">
                <span className="user-name">{userInfo.displayName}</span>
                <span className="user-email">{userInfo.mail}</span>
              </div>
              <div className="header-user-actions">
                <img src={logoMobile} alt="WIJeindhoven" className="header-user-logo-mobile" />
                <button onClick={handleLogout} className="btn-logout">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 3H4C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H9M13 13L17 9M17 9L13 5M17 9H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className="logout-text">Uitloggen</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};